import React, { useState, useEffect } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import TabProfile from "./TabCustomerProfile";
import useLocationData from "../../hooks/useLocationData";
import { languagesData } from "../../utils/fackData/languagesData";
import MultiSelectTags from "../../components/shared/MultiSelectTags";

const CustomerCreateContent = () => {
  const navigate = useNavigate();

  // Seçenekler: Roller, Diller, Avatar Listesi
  const [rolesOptions, setRolesOptions] = useState([]);
  const [languagesOptions, setLanguagesOptions] = useState([]);
  const [avatarList, setAvatarList] = useState([]);

  // Form verileri
  const [customerData, setCustomerData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    country: "",
    language: "",
    password: "",
    confirmPassword: "",
    profileImage: "",
    role_id: "",
  });

  // 📌 Kendi locationData hook'unu kullan
  const {
    countries, // Ülke listesi
    states, // Eyalet/İl listesi
    cities, // Şehir listesi
    loading,
    error,
    fetchStates,
    fetchCities,
  } = useLocationData();

  // Sayfa açılırken roller, diller ve avatar listesi çek
  useEffect(() => {
    fetchAvatars();
    fetchRoles();
    fetchLanguages();
  }, []);

  const fetchAvatars = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/avatars`,
      );
      // Sunucudan sadece "avatar1.png" vb. geliyor
      const avatarPaths = response.data.map((fileName) => `${fileName}`);
      setAvatarList(avatarPaths);
    } catch (error) {
      console.error("Avatarlar yüklenirken hata:", error);
    }
  };

  const fetchRoles = async () => {
    try {
      const token = localStorage.getItem("admin_token");
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/roles`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      // API'den gelen veriyi doğru formata çevir
      const activeRoles = response.data
        .filter((role) => role.status === 1)
        .map((role) => ({
          label: role.role_name, // Kullanıcıya gösterilecek isim
          value: role.id?.toString() || "", // ID'yi string formatına çevir
        }));

      setRolesOptions(activeRoles);
    } catch (error) {
      console.error("Roller alınamadı:", error);
    }
  };

  // 3) Dilleri al
  const fetchLanguages = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/languages/list/active`,
      );
      const languages = response.data.map((lang) => ({
        label: lang.name,
        value: lang.code, // veritabanında code saklayabilirsin
      }));
      setLanguagesOptions(languages);
    } catch (error) {
      console.error("Diller alınamadı:", error);
    }
  };

  const handleSubmit = async () => {
    if (customerData.password !== customerData.confirmPassword) {
      toast.error("Şifreler eşleşmiyor!");
      return;
    }

    // role_id boşsa, role_name kullanarak bir ID bul
    const selectedRole = rolesOptions.find(
      (role) => role.label === customerData.role_name,
    );
    const roleId = selectedRole ? selectedRole.value : null; // Eğer role_id boşsa, role_name kullan

    // Backend'e gönderilecek temiz veri
    const requestData = {
      firstName: customerData.firstName,
      lastName: customerData.lastName,
      email: customerData.email,
      phone: customerData.phone,
      country: customerData.country,
      language: customerData.language,
      password: customerData.password,
      profileImage: customerData.profileImage,
      role_id: 2,
    };

    try {
      const token = localStorage.getItem("admin_token");
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/user/create`,
        requestData, // Yalnızca gerekli alanları gönderiyoruz
        { headers: { Authorization: `Bearer ${token}` } },
      );

      toast.success("Kullanıcı başarıyla eklendi!");
      navigate("/customers/list"); // Kullanıcı eklenince yönlendir
    } catch (error) {
      toast.error("Kullanıcı eklenirken hata oluştu!");
      console.error("Kullanıcı ekleme hatası:", error.response?.data || error);
    }
  };

  return (
    <div className="col-lg-12">
      <ToastContainer />
      <div className="card white-body">
        {/* White-body card yapısı */}
        <div className="tab-content">
          <TabProfile
            // Form verisi
            customerData={customerData}
            setCustomerData={setCustomerData}
            // Seçenekler
            rolesOptions={rolesOptions}
            languagesOptions={languagesData}
            avatarList={avatarList}
            // Ulke, eyalet, sehir listeleri
            countries={countries}
            states={states}
            cities={cities}
            fetchStates={fetchStates}
            fetchCities={fetchCities}
            // Kaydet butonuna basılınca
            handleSubmit={handleSubmit}
          />
        </div>
      </div>
    </div>
  );
};

export default CustomerCreateContent;
